// Lib
import React, { ReactElement, CSSProperties } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Util
import { getAvatarStyle } from './userAvatarUtils';
import { scaleToGrid } from '../../utils/grid/gridUtils';

// Styles
import './UserAvatarCount.scss';

type UserAvatarCountProps = {
    size: number;
    gridSize: number;
    hiddenUserCount: number;
};

const MAX_AVATAR_COUNT = 99;

const UserAvatarCount = (props: UserAvatarCountProps): ReactElement => {
    const { hiddenUserCount, size, gridSize } = props;
    const sizePx = Math.ceil(scaleToGrid(size, gridSize));

    const countCeiling = Math.min(hiddenUserCount, MAX_AVATAR_COUNT);

    return (
        <div className={classNames('UserAvatar UserAvatarCount')} style={getAvatarStyle(sizePx) as CSSProperties}>
            <div className="avatar-contents">
                <span className="user-count">+{countCeiling}</span>
            </div>
        </div>
    );
};

UserAvatarCount.propTypes = {
    size: PropTypes.number.isRequired,
    gridSize: PropTypes.number,
    hiddenUserCount: PropTypes.number,
};

export default UserAvatarCount;
